import React from 'react'

const Loading = (props) => {
    return (
        <svg {...props} style={props.style} xmlns="http://www.w3.org/2000/svg"><path fill={props.fill}  d="M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur={props.duration} from="0 50 50" to="360 50 50" repeatCount="indefinite"/></path></svg>
    )
}

Loading.propTypes = {}

Loading.defaultProps = {}

export default Loading



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Loading/index.js